import { type FC } from 'react';
import { Spinner } from 'react-bootstrap';
import cn from 'classnames';
import styles from './inputSpinner.module.scss';

interface InputSpinnerProps {
  /** Показывать индикатор загрузки внутри поля. */
  loading: boolean;
  /** Доп. класс — на случай точечной подгонки позиции в конкретном поле. */
  className?: string;
  /** Подпись для скринридеров. */
  label?: string;
}

/**
 * Индикатор загрузки внутри текстового поля (поиск с дебаунсом).
 *
 * Позиционируется по правому краю поля, поэтому контейнер поля должен иметь
 * `position: relative`. При `loading=false` не рендерит ничего — разметка поля
 * остаётся прежней.
 */
export const InputSpinner: FC<InputSpinnerProps> = ({
  loading,
  className,
  label = 'Идёт поиск'
}) => {
  if (!loading) {
    return null;
  }

  return (
    <span
      className={cn(styles['input-spinner'], className)}
      role="status"
      aria-label={label}
    >
      <Spinner as="span" animation="border" size="sm" aria-hidden="true" />
    </span>
  );
};
